import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export const createGroup = (chatName: string, members: Array<string>, _id: string) => {
  return Http.request<string>({
    method: 'POST',
    url: `${API_CHAT_URL}/pairing/create-group`,
    body: {
      chatName,
      members,
      _id,
    },
  });
};
